var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldSecurity = function SvgShieldSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.04 68"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:var(--konflux-icon-color, #1A1A1A);stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-2{fill:var(--konflux-primary-color, #FF9D76);stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.47,57.52l-5.6-39.2c-.22-1.55.79-3,2.32-3.33l22.95-5.1c.86-.19,1.74-.19,2.6,0l22.95,5.1c1.53.34,2.54,1.79,2.32,3.33l-5.6,39.2c-.21,1.48-1.5,10.48-20.97,10.48s-20.75-9-20.97-10.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.11,30.31l8.99,8.99,14.98-14.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.63,49.78L2.03,10.58c-.22-1.55.79-3,2.32-3.33L27.3,2.14c.86-.19,1.74-.19,2.6,0l22.95,5.1c1.53.34,2.54,1.79,2.32,3.33l-5.6,39.2c-.21,1.48-1.5,10.48-20.97,10.48s-20.75-9-20.97-10.48Z"
  }))));
};
export default SvgShieldSecurity;